export const icon = {
  not_found: require('./not_found.png'),
  server_error: require('./server_error.png'),
  connection_error: require('./connection_error.png'),
  play: require('./play.png'),
  myket: require('./myket.png'),
  bazar: require('./bazar.png'),
  android: require('./android.png'),
};
